

import { Button, Dialog, DialogContent, DialogTitle, Grid } from '@material-ui/core';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import React, { useEffect, useState } from 'react';
import CustomInput from '../../../../components/CustomInput';
import DropdownFilter from '../../../../components/DropdownFilter';
import NotificationProvider from '../../../../components/NotificationProvider';
import FormatService from '../../../../services/formatService';
import statuses from '../../loadStatusesWithIcons';
import { useAddStatusMutation, useGetLoadStatusReasonsQuery, useUpdateStatusMutation } from '../../loadsSlice';
import { loadStatusUpdateStyle } from './LoadStatusUpdateStyle';
import _ from 'lodash';
import { loadStatusReasonOwnerObj, loadStatusReasonOwner } from '../LoadsDashboard/loadsDashboardConsts';
import { loadStatuses } from 'features/loads/enums';

function LoadStatusUpdate({
    loads,
    statusToEdit,
    forEdit = false,
    onClose,
    btnStyle = 'contained'
}) {
    const classes = loadStatusUpdateStyle()

    let [addStatus, { isLoading: isLoadingAddStatus, isSuccess: addStatusSuccess }] = useAddStatusMutation();
    let [updateStatus, { isLoading: isLoadingUpdateStatus, isSuccess: updateStatusSuccess }] = useUpdateStatusMutation();
    let { data: statusReasonsData, error: statusReasonsError, isLoading: isLoadingStatusReasons } = useGetLoadStatusReasonsQuery();

    statusReasonsData = statusReasonsData || [];
    statusReasonsData = statusReasonsData?.map(sr => {
        return {
            ...sr,
            name: `${sr.reasonText} ${sr.owner == loadStatusReasonOwner.TENANT ? '' : `(${loadStatusReasonOwnerObj?.[sr.owner]?.name})`}`
        }
    })?.sort((a, b) => a?.name?.localeCompare(b?.name));

    const statusReasons = statusReasonsData.filter(x => x.parentReasonId == null) || [];
    const statusSubReasons = statusReasonsData.filter(x => x.parentReasonId != null);

    const statusReasonsLookup = _.groupBy(statusReasons, 'statusId');
    const statusSubReasonsLookup = _.groupBy(statusSubReasons, 'parentReasonId');

    const [open, setOpen] = useState(false);
    const [statusDate, setStatusDate] = React.useState(new Date());
    const [status, setStatus] = React.useState();
    const [comment, setComment] = React.useState();
    const [reasonId, setReasonId] = React.useState();
    const [subReasonId, setSubReasonId] = React.useState();
    const [showError, setShowError] = useState(false);
    const [showStatusReason, setShowStatusReason] = useState(false);

    let statusReasonsValues = status == loadStatuses.CANCELLED_PARQ ? statusReasonsLookup[loadStatuses.CANCELLED] : statusReasonsLookup[status];
    let statusSubReasonsValues = statusSubReasonsLookup[reasonId];

    useEffect(() => {
        if (statusToEdit?.id) {
            setOpen(!!statusToEdit);
            setStatusDate(FormatService.formatDateTime(statusToEdit?.statusDate));
            setStatus(statusToEdit?.status);
            setComment(statusToEdit?.comment);
            if (Object.keys(statusReasonsLookup)?.includes(statusToEdit?.status?.toString()) || status == loadStatuses.CANCELLED_PARQ) {
                setReasonId(statusToEdit?.reasonId);
                setSubReasonId(statusToEdit?.subReasonId);
                setShowStatusReason(true);
            } else {
                setReasonId(null);
                setShowStatusReason(false);
            }
        } else {
            setOpen(false);
        }
    }, [statusToEdit]);

    let statusConfig = Object.entries(statuses).map(([key, value]) => ({ name: value.label, id: key })) ?? [];
    const supportedStatues = ["1", "3", "4", "5", "6", "10", "11", "12"];
    let filteredStatuses = statusConfig.filter(status => supportedStatues.includes(status.id));

    const onSelectStatus = (e) => {
        setStatus(e)
        if (e) {
            setShowError(false)
        }
        if (Object.keys(statusReasonsLookup)?.includes(e)) {
            setShowStatusReason(true);
        } else {
            setShowStatusReason(false);
            setReasonId(null);
            setSubReasonId(null);
        }
    }

    const onSelectTime = (e) => {
        setStatusDate(e)
    }

    const onSelectReason = (e) => {
        setReasonId(e)
        setSubReasonId(null);
    }
    
    const onSelectSubReason = (e) => {
        setSubReasonId(e)
    }

    const showSubReason = (reasonId) => {
        return reasonId && statusSubReasonsValues && <Grid className={classes.subBox}>
            <DropdownFilter
                title='Sub Reason'
                values={statusSubReasonsValues}
                onSelect={onSelectSubReason}
                value={subReasonId}
                showEmpty={true} 
                />
        </Grid>
    }

    const onUpdateStatus = async () => {
        if (!status) {
            setShowError(true)
        }
        else {
            setShowError(false)
            let utcStatusDate = new Date(statusDate);
            if (statusToEdit?.id) {
                let result = await updateStatus({
                    id: statusToEdit.id,
                    loadId: loads?.[0]?.id,
                    groupId: loads?.[0]?.groupId,
                    status: status,
                    statusDate: new Date(utcStatusDate.toUTCString()),
                    comment: comment,
                    reasonId: reasonId,
                    subReasonId: subReasonId
                });
                if (result?.error) {
                    NotificationProvider.error(`Failed to update status`)
                } else {
                    NotificationProvider.success(`Successfully update status`);
                }
            } else {
                let result = await addStatus({
                    loadIds: loads?.map(l => l.id),
                    groupIds: loads?.map(l => l.groupId),
                    status: status,
                    statusDate: new Date(utcStatusDate.toUTCString()),
                    comment: comment,
                    reasonId: reasonId,
                    subReasonId: subReasonId
                });
                if (result?.error) {
                    NotificationProvider.error(`Failed to update status`)
                } else {
                    NotificationProvider.success(`Successfully update status`);
                }
            }
            onClose && onClose();
            setOpen(false);
        }

    }
    const fields = [
        {
            size: 12,
            title: 'Status',
            key: 'status',
            values: statusConfig,
            component: statusToEdit ? <b>{statusConfig?.find(s => s.id == status)?.name}</b> : <DropdownFilter
                title='Status'
                values={statusToEdit ? statusConfig : filteredStatuses}
                onSelect={onSelectStatus}
                value={status}
                showEmpty={true} />
        },
        {
            type: 'dateTime',
            size: 12,
            title: 'Date',
            key: 'date',
            component: <div className={classes.label}>
                <LocalizationProvider
                    dateAdapter={AdapterDateFns} >
                    <Stack spacing={3}>
                        <DateTimePicker
                            label='Date'
                            value={statusDate}
                            onChange={onSelectTime}
                            renderInput={(params) =>
                                <TextField {...params}
                                    sx={{ svg: { color: '#0090FE' } }}
                                />}
                        />
                    </Stack>
                </LocalizationProvider></div>
        },
        (showStatusReason || status == loadStatuses.CANCELLED_PARQ) ? {
            size: 12,
            title: 'Reason',
            key: 'reasonId',
            component: <><DropdownFilter
                title='Reason'
                values={statusReasonsValues}
                onSelect={onSelectReason}
                value={reasonId}
                showEmpty={true} />
                {showSubReason(reasonId)}
                </>
        } : null,
        {
            type: 'text',
            size: 12,
            title: 'Comment',
            key: 'comment',
            component: <>
                {status == 10 && !comment && <div className={classes.commentReminder}>{'Please add a comment explaining what the exception is'}</div>}
                <CustomInput
                    id="comments"
                    label="Comments"
                    value={comment}
                    elementType="textarea"
                    onChange={val => setComment(val)}
                /></>
        }
    ];

    return (
        <div>
            {!forEdit && <Button
                variant={btnStyle}
                color="primary"
                onClick={() => setOpen(true)}
            >
                Update status
            </Button>}
            <Dialog
                open={open}
                onClose={() => {
                    setOpen(false);
                    onClose && onClose();
                }
                }
                aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Update Status</DialogTitle>
                <DialogContent>
                    <>
                        {showError &&
                            <div className={classes.error}>Please choose a status</div>
                        }
                        {fields &&
                            fields.map((field, index) => (
                                <>
                                    {field && <Grid className={classes.box} key={index} item xs={field?.size}>
                                        {field.component}
                                    </Grid>}
                                </>
                            ))
                        }
                    </>
                    <Button
                        className={classes.dispatchButton}
                        variant="contained"
                        color="primary"
                        disabled={isLoadingAddStatus || isLoadingUpdateStatus}
                        onClick={onUpdateStatus}
                    >
                        {isLoadingUpdateStatus ? 'Saving' : 'Update'}
                    </Button>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default LoadStatusUpdate;